/* unplugin-vue-components disabled */import { render } from "./BaseLayout.vue?vue&type=template&id=717bdf6c&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"

import "./BaseLayout.vue?vue&type=style&index=0&id=717bdf6c&scoped=true&lang=css"

import exportComponent from "D:\\qianniao-project\\cloudbirds-support\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717bdf6c"]])

export default __exports__